export default __webpack_public_path__ + "static/media/glen-logo.0ebb0d0c.png";